// La Sala de Control en el móvil (revisión de la sala, 22-10: en el móvil no había forma de abrirla; el móvil es pantalla
// principal). Cerrada: una franja encima de la lista del equipo con las ventas de hoy frente a ayer. Abierta
// (?sala=<pestaña>, como en escritorio): la ventana de la sala a pantalla completa, con su cierre.
import { Radio } from 'lucide-react';
import { t } from '../../../i18n';
import { cn } from '../../../lib/utils';
import { delta, numero, SIN_VALOR } from './formato';
import { useSalaPulso } from './useSalaPulso';
import { PESTANAS, VentanaSala, type PestanaSala } from './VentanaSala';

export function SalaMovil({ pestana, alCambiar }: { pestana: string | null; alCambiar: (p: PestanaSala | null) => void }) {
  const { pulso, fallo } = useSalaPulso();
  if (pestana !== null) {
    const actual: PestanaSala = (PESTANAS as string[]).includes(pestana) ? (pestana as PestanaSala) : 'pulso';
    return (
      <div className="fixed inset-0 z-40 bg-oficina-fondo pb-safe-bottom pl-safe-left pr-safe-right pt-safe-top">
        <VentanaSala movil pulso={pulso} fallo={fallo} pestana={actual} alCambiarPestana={alCambiar} alCerrar={() => alCambiar(null)} />
      </div>
    );
  }
  const v = pulso?.ventas;
  const d = v ? delta(v.hoy, v.ayer, false) : null;
  return (
    <button
      type="button"
      onClick={() => alCambiar('pulso')}
      data-testid="entrada-sala-movil"
      className="mb-2 flex min-h-11 w-full items-center gap-3 rounded-o-l bg-oficina-elevada px-4 py-2.5 text-left outline-none focus-visible:ring-2 focus-visible:ring-oficina-acento/60"
    >
      <Radio className="h-5 w-5 shrink-0 text-oficina-marca" aria-hidden />
      <span className="flex-1 text-o-cuerpo font-semibold">{t('salaControl.titulo')}</span>
      <span className="text-o-titulo3 font-bold tabular-nums">{v ? `${numero(v.hoy / 1000, 1)} k$` : SIN_VALOR}</span>
      {d && d.direccion !== 'igual' ? (
        <span className={cn('text-o-sub', d.tono === 'bueno' ? 'text-oficina-trabajando' : 'text-oficina-error')}>{`${d.direccion === 'sube' ? '↑' : '↓'} ${d.texto}`}</span>
      ) : null}
    </button>
  );
}
